
import type { CSSProperties } from 'vue';

import { defineComponent, computed } from 'vue';

export default defineComponent({
  name: 'SvgIcon',
  props: {
    prefix: {
      type: String,
      default: 'icon',
    },
    name: {
      type: String,
      default: '',
    },
    size: {
      type: [Number, String],
      default: 16,
    },
    spin: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const symbolId = computed(() => `#${props.prefix}-${props.name}`);
    const getStyle = computed((): CSSProperties => {
      const { size } = props;
      let s = `${size}`;
      s = `${s.replace('px', '')}px`;
      const sArray = s.split(' ');
      return {
        width: sArray[0],
        height: sArray.length === 2 ? sArray[1] : sArray[0],
      };
    });
    return { symbolId, getStyle };
  },
});
